/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sync_Phase_Collecting_CountInputs */



/**
* | output |
* | --- |
* | "Collecting files... ({count})" |
*
* @param {Sync_Phase_Collecting_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_phase_collecting_count = /** @type {((inputs: Sync_Phase_Collecting_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Phase_Collecting_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dateien werden gesammelt... (${i?.count})`)
	return /** @type {LocalizedString} */ (`Collecting files... (${i?.count})`)
});